import React from 'react';
interface QuotationTermsProps {
  termsAndConditions: string;
  additionalNotes?: string;
}
export function QuotationTerms({
  termsAndConditions,
  additionalNotes
}: QuotationTermsProps) {
  return <div className="space-y-5 mb-6" data-id="element-992">
      {/* Terms & Conditions */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-993">
        <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-3" data-id="element-994">
          Terms & Conditions
        </h3>
        <div className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-995">
          {termsAndConditions}
        </div>
      </div>

      {/* Additional Notes */}
      {additionalNotes && <div className="bg-blue-50/50 border border-blue-200 rounded-lg p-5" data-id="element-996">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-3" data-id="element-997">
            Additional Notes
          </h3>
          <div className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-998">
            {additionalNotes}
          </div>
        </div>}
    </div>;
}